<!-- @prettier -->
<template>
	<ConfirmationModal
		:entity="ringTree"
		:title="$t('DELETE_PING_TREE_MODAL_TITLE')"
		:confirm-action-text="$t('DELETE')"
		:cancel-button-text="$t('CANCEL')"
		:confirm-button-loading="loadingDeletingRingTree"
		:show-cancel-button="showActions"
		:show-confirm-button="showActions"
		@confirm="confirmDelete"
		@close="closeDeleteModal"
	>
		<div v-if="!ringTreeReferences && loadingRingTreeReferences">
			<Loader custom-class="size-sm" />
			<span
				v-html="$t(checkReferencesText, { pingTreeName: ringTree.name })"
			></span>
		</div>

		<p
			v-if="ringTreeReferences && !hasReferences"
			v-html="
				$t('DELETE_PING_TREE_MODAL_NONE_ASSOCIATION_TEXT', {
					pingTreeName: ringTree.name
				})
			"
		></p>

		<div v-if="ringTreeReferences && hasReferences">
			<p
				v-html="
					$t('DELETE_PING_TREE_MODAL_ASSOCIATION_TEXT', {
						pingTreeName: ringTree.name
					})
				"
			></p>

			<div class="well well-sm m-t-10 m-b-0">
				<div class="form-horizontal">
					<!-- campaigns -->
					<div
						class="row"
						v-if="
							ringTreeReferences.campaigns &&
								ringTreeReferences.campaigns.length > 0
						"
					>
						<label class="col-md-3 control-label">
							<strong>Campaigns</strong>
						</label>
						<div class="col-md-8">
							<ul class="list-unstyled form-control-static list-text-overflow">
								<li
									v-for="campaign in ringTreeReferences.campaigns"
									:key="campaign.campaignId"
								>
									<a
										v-tooltip.right.hover="$t('VIEW_CAMPAIGN')"
										:href="`#/dashboard/campaign/${campaign.campaignId}`"
										target="_blank"
									>
										<span class="display-text" :title="campaign.campaignName">
											{{ campaign.campaignName }}
										</span>
										<i class="fa fa-external-link m-l-5"></i>
									</a>
								</li>
							</ul>
						</div>
					</div>

					<!-- Ring Tree Targets -->
					<div
						class="row"
						v-if="
							ringTreeReferences.pingtreetargets &&
								ringTreeReferences.pingtreetargets.length > 0
						"
					>
						<label class="col-md-3 control-label">
							<strong>Ring Tree Targets</strong>
						</label>
						<div class="col-md-8">
							<ul class="list-unstyled form-control-static list-text-overflow">
								<li
									v-for="pingtreetarget in ringTreeReferences.pingtreetargets"
									:key="pingtreetarget.pingtreetargetId"
								>
									<a
										v-tooltip.right.hover="
											$t('DELETE_PING_TREE_MODAL_VIEW_TARGET')
										"
										:href="
											`#/dashboard/ringtreetarget/edit/${pingtreetarget.pingtreetargetId}`
										"
										target="_blank"
									>
										<span
											class="display-text"
											:title="pingtreetarget.pingtreetargetName"
										>
											{{ pingtreetarget.pingtreetargetName }}
										</span>
										<i class="fa fa-external-link m-l-5"></i>
									</a>
								</li>
							</ul>
						</div>
					</div>

					<!-- Routing Plans -->
					<div
						class="row"
						v-if="
							ringTreeReferences.callplans &&
								ringTreeReferences.callplans.length > 0
						"
					>
						<label class="col-md-3 control-label">
							<strong>Routing Plans</strong>
						</label>
						<div class="col-md-8">
							<ul class="list-unstyled form-control-static list-text-overflow">
								<li
									v-for="callplan in ringTreeReferences.callplans"
									:key="callplan.callplanId"
								>
									<span class="display-text" :title="callplan.callplanName">
										{{ callplan.callplanName }}

										<i
											v-if="callplan.callplanNoRoutes"
											v-tooltip.right.hover="
												$t('NO_ROUTE_SETUP_WARNING_PING_TREE')
											"
											class="fa fa-exclamation-circle text-danger f-s-14 m-l-5"
										></i>
									</span>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>

			<!-- check box -->
			<div class="form-horizontal m-l-10 m-r-10">
				<div class="checkbox">
					<label>
						<input
							type="checkbox"
							v-model="forceUnlink"
							@change="setForceUnlink"
						/>
						<span v-t="'DELETE_PING_TREE_MODAL_CHECKBOX'"></span>
					</label>
				</div>
			</div>
		</div>
	</ConfirmationModal>
</template>

<script>
import ConfirmationModal from '@/core/components/ConfirmationModal/ConfirmationModal';
import Loader from '@/core/components/Loader';
import sharedMessages from '@/core/locales';
import messages from '../locales';
import NzToggle from '@/core/components/nzToggle/nzToggle';

export default {
	name: 'RingTreeDeleteModal',
	components: {
		ConfirmationModal,
		Loader,
		NzToggle
	},
	props: {
		ringTree: {
			type: Object,
			default: function() {
				return {};
			}
		},
		ringTreeReferences: {
			type: Object,
			default: function() {
				return {};
			}
		},
		loadingDeletingRingTree: {
			type: Boolean,
			default: false
		},
		loadingRingTreeReferences: {
			type: Boolean,
			default: false
		},
		checkReferencesText: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			forceUnlink: false
		};
	},
	computed: {
		showActions() {
			return !!this.ringTreeReferences;
		},
		hasReferences() {
			return this.ringTreeReferences?.hasReferences || false;
		}
	},
	methods: {
		confirmDelete(ringTree) {
			this.$emit('confirm', ringTree);
		},
		closeDeleteModal() {
			this.$emit('close');
		},
		setForceUnlink() {
			this.$emit('set-force-unlink', this.forceUnlink);
		}
	},
	i18n: {
		messages,
		sharedMessages,
		locale: 'en'
	}
};
</script>
